import React from "react";
import { Button, Rating } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Observer, observer } from "mobx-react-lite";
import { useAppState } from "../../states/app-state";
import { TRiderInfo } from "../../api/bearer-api";
import ShowImage from "../showImage/ShowImage";
import DisabledClickLoading from "../../components/DisabledClickLoading";
import styles from './TransportRate.module.scss'; // added by Bearer Web Developer
import GoogleReview from "./googleReview"; // added by Bearer Web Developer
import { useThemeMode } from "../../states/contexts/theme";  // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer


const TransportRate: React.FC = observer(() => {

    const appState = useAppState();
    const rating = appState.selectedOrder!.transport.rating;
    const order = appState.selectedOrder!;
    const riderInfo = order!.transport.riderInfo!;
    const bearer_type = riderInfo?.assigned_bearer_type || riderInfo.bearer_type; // added by Bearer Web Developer
    const riding = bearer_type === "riding"; // added by Bearer Web Developer
    const driving = bearer_type === "driving"; // added by Bearer Web Developer
    const [loading, setLoading] = React.useState(false);
    const handleConfirm = async () => {
        setLoading(true);
        await appState.selectedOrder?.transport.rating.customerRateTransport();
        setLoading(false);
    }

    const [loadingSkip, setLoadingSkip] = React.useState(false);
    const handleSkipRatingButton = async () => {
        setLoadingSkip(true);
        await appState.selectedOrder?.transport.rating.customerSkipRating();
        setLoadingSkip(false);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <div className={styles.transport_rate} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.header}>
                <div>
                    <h3>Please rate this transport:</h3>
                </div>
                <div>
                    <Button
                        className={styles.skip}
                        onClick={handleSkipRatingButton}
                        disabled={loadingSkip}
                    >
                        Skip
                    </Button>
                    {loadingSkip && <DisabledClickLoading />}
                </div>
            </div >
            <div className={styles.rider_info}>
                <div className={styles.image}>
                    <div className={styles.image_box}>
                        <ShowImage fireBaseUrl={riderInfo.rider_avatar_url} />
                    </div>
                    <p>{riderInfo.rider_given_name} {riderInfo.rider_last_name}</p>
                </div>
                <div className={styles.type_riding}>
                    <div>
                        {riding &&
                            <>
                                <p>{riderInfo.motorbike_make} {riderInfo.motorbike_model}</p>
                                <div className={styles.motorbike_registration}>
                                    <h5> {riderInfo.motorbike_registration_number}</h5>
                                    <h6>{riderInfo.motorbike_registration_state}</h6>
                                </div>
                            </>
                        }
                        {/* added by Bearer Web Developer start */}
                        {driving &&
                            <>
                                <p>{riderInfo.car_make} {riderInfo.car_model}</p>
                                <div className={styles.car_registration}>
                                    <h5> {riderInfo.car_registration_number}</h5>
                                    <h6>{riderInfo.car_registration_state}</h6>
                                </div>
                            </>
                        }
                        {/* added by Bearer Web Developer end */}
                        {/* added by Bearer Web Developer start */}
                        {!riding && !driving &&
                            <div className={styles.not_rider}>
                                <div className={''}>
                                    {/* In the following drone and rover added by Bearer Web Developer  */}
                                    {bearer_type === "walking" ? <img src="/directions_run_transport_info.png" alt="walking" />
                                        : bearer_type === "drone" ? <img src="/drone.webp" alt="drone" width={50} height={50} />
                                        : bearer_type === "rover" ? <img src="/rover.webp" alt="rover" width={50} height={50} />
                                        : <img src="/pedal_bike_transport_info.png" alt="cycling" />
                                    }
                                </div>
                                <h5>
                                    {bearer_type.slice(0, 1).toLocaleUpperCase()
                                        + bearer_type.slice(1).toLocaleLowerCase()}
                                </h5>
                            </div>
                        }
                        {/* added by Bearer Web Developer end */}
                    </div>
                </div>
            </div>
            <div className={styles.rating}>
                <div className={styles.rate}>
                    <h4>Safe Delivery</h4>
                    <Observer>{() => (
                        <Rating
                            value={rating.safeDelivery}
                            onChange={(_, newValue) => {
                                rating.setSafeDelivery(newValue);
                            }}
                            emptyIcon={<StarBorderIcon className={styles.star} />}
                        />
                    )}</Observer>
                </div>
                <div className={styles.rate}>
                    <h4>Bearer’s Behavior</h4>
                    <Observer>{() => (
                        <Rating
                            value={rating.politeness}
                            onChange={(_, newValue) => {
                                rating.setPoliteness(newValue);
                            }}
                            emptyIcon={<StarBorderIcon color="inherit" className={styles.star} />}
                        />
                    )}</Observer>
                </div>
                <div className={styles.rate}>
                    <h4>Service Speed</h4>
                    <Observer>{() => (
                        <Rating
                            value={rating.speed}
                            onChange={(_, newValue) => {
                                rating.setSpeed(newValue);
                            }}
                            emptyIcon={<StarBorderIcon classes={{ root: styles.star }} />}
                        />
                    )}</Observer>
                </div>
            </div>
            <GoogleReview /> {/* added by Bearer Web Developer */}
            <AddressLine riderInfo={riderInfo} />
            <div>
                <Observer>{() => {
                    const valid = !!rating.politeness && !!rating.safeDelivery && !!rating.speed;
                    return (
                        <>
                            <Button
                                onClick={handleConfirm}
                                disabled={!valid}
                                className={styles.submit}
                            >
                                Submit
                            </Button>
                            {loading && <DisabledClickLoading />}
                        </>
                    );
                }}</Observer>
            </div>
        </div>
    )
    // modified by Bearer Web Developer end
})

export default TransportRate;



const AddressLine: React.FC<{ riderInfo: TRiderInfo }> = observer(({ riderInfo }) => {
    
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <Timeline classes={{ root: styles.time_line }}>
            <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content }}>
                <TimelineSeparator>
                    {
                        theme === 'dark' ?
                            <img src="/origin-dark.svg" alt="origin" /> :
                            <img src="/origin.png" alt="origin" />
                    }
                    <TimelineConnector className={''} />
                </TimelineSeparator>
                <TimelineContent className={styles.content}>{riderInfo!.origin_address}</TimelineContent>
            </TimelineItem>
            <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content, root: styles.timelineItem_root }}>
                <TimelineSeparator >
                    <img src="/destination.png" alt="destination" />
                </TimelineSeparator>
                <TimelineContent className={styles.content}>{riderInfo!.destination_address}</TimelineContent>
            </TimelineItem>
        </Timeline>
    )
    // modified by Bearer Web Developer end
})




